export interface EmailAccount {
    _id: string
    email: string
    provider: string
    grantId: string
    status: 'valid' | 'invalid' | 'revoked'
}

export interface AuthUrlResponse {
    authUrl: string
}

export interface TokenExchangeResponse {
    success: boolean
    grant_id: string
    access_token: string
}

export class ApiError extends Error {
    constructor(
        message: string,
        public status?: number
    ) {
        super(message)
        this.name = 'ApiError'
    }
}
